import { jsxs as o, jsx as l } from "react/jsx-runtime";
const t = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m33.617 46.075-4.418 1.184 1.184 4.418 4.418-1.184-1.184-4.418Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M49.481 52.904V6.028H18.52a4 4 0 0 0-4 4V53.97a4 4 0 0 0 4 4h28.036l-1.071-3.996h-26.97V43.97h26.97v10.004l3.996-1.071v.001ZM18.515 41.973V10.024h26.97v31.95h-26.97v-.001ZM9.341 40.982c-2.105-2.439-3.263-5.629-3.263-8.981 0-3.352 1.159-6.543 3.263-8.981l2.268 1.958c-1.635 1.895-2.536 4.389-2.536 7.023 0 2.634.901 5.128 2.536 7.023l-2.268 1.958ZM54.707 23.018c2.105 2.439 3.263 5.629 3.263 8.981 0 3.352-1.159 6.543-3.263 8.981l-2.268-1.958c1.635-1.895 2.536-4.389 2.536-7.023 0-2.634-.901-5.128-2.536-7.023l2.268-1.958Z"
        }
      )
    ]
  }
);
export {
  t as PingDriver
};
